import { render } from "./Badges.vue?vue&type=template&id=6c03d8fe&scoped=true"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"

import "./Badges.vue?vue&type=style&index=0&id=6c03d8fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c03d8fe"]])

export default __exports__